module.exports = __webpack_public_path__ + "static/MessinaSansWeb-Regular-91c8fb681281f58452d7cb34deb11484.woff2";